import { fetchApi } from "./api";
import { API_ENDPOINTS } from "@/config/api";
import type { LoginRequest, SignupRequest, User } from "@/types/auth";

export async function login(credentials: LoginRequest): Promise<User> {
  // Convert to URL-encoded form data (OAuth2 password flow standard)
  const formData = new URLSearchParams();

  // Backend expects 'username' field, but can accept email or username as value
  const username = credentials.username || credentials.email || "";
  formData.append("username", username);
  formData.append("password", credentials.password);

  return fetchApi<User>(API_ENDPOINTS.login, {
    method: "POST",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
    body: formData.toString(),
  });
}

export async function signup(data: SignupRequest): Promise<User> {
  return fetchApi<User>(API_ENDPOINTS.signup, {
    method: "POST",
    body: JSON.stringify(data),
  });
}

export async function logout(): Promise<void> {
  await fetchApi<void>(API_ENDPOINTS.logout, {
    method: "POST",
  });
}

export async function getCurrentUser(): Promise<User> {
  return fetchApi<User>(API_ENDPOINTS.userInfo);
}
